import { useAuthContext } from "@asgardeo/auth-react";

const AccessDenied = () => {
    const { signOut } = useAuthContext();

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                fontFamily: "inherit",
                textAlign: "center",
                padding: "2rem",
            }}
        >
            <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
                Access Denied
            </h1>
            <p style={{ fontSize: "1.1rem", color: "#666", maxWidth: "480px" }}>
                You have signed in successfully, but your account does not have
                permission to access this environment. Please contact your
                administrator to be added to the required group.
            </p>
            <button
                onClick={() => signOut()}
                style={{
                    marginTop: "2rem",
                    padding: "0.75rem 2rem",
                    fontSize: "1rem",
                    backgroundColor: "#1a1a2e",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                }}
            >
                Sign Out
            </button>
        </div>
    );
};

export default AccessDenied;
